var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterillustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1302,
    height: 127,
    viewBox: "0 0 1302 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90.413C162.75 63.2891 343.583 108.496 524.417 81.3717C705.25 54.2478 886.083 103.975 1066.92 74.1387C1184.46 59.6726 1256.79 85.8924 1302 79.5635V126.578H0V90.413Z",
    fill: "white",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 103.975C217 83.1798 434 117.537 651 97.6459C868 77.755 1085 113.016 1302 94.9335V126.578H0V103.975Z",
    fill: "white",
    fillOpacity: 0.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2913 81.3716C77.2733 81.3716 88.6079 65.9894 88.6079 47.0146C88.6079 28.0398 77.2733 12.6577 63.2913 12.6577C49.3093 12.6577 37.9746 28.0398 37.9746 47.0146C37.9746 65.9894 49.3093 81.3716 63.2913 81.3716Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0041 77.7551H60.5791V95.8377H66.0041V77.7551Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.666 68.7139C154.653 68.7139 162.75 55.7605 162.75 39.7818C162.75 23.803 154.653 10.8496 144.666 10.8496C134.679 10.8496 126.583 23.803 126.583 39.7818C126.583 55.7605 134.679 68.7139 144.666 68.7139Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.475 65.0974H141.954V90.413H146.475V65.0974Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.208 80.4676C265.704 80.4676 268.537 77.6341 268.537 74.1387C268.537 70.6434 265.704 67.8098 262.208 67.8098C258.713 67.8098 255.879 70.6434 255.879 74.1387C255.879 77.6341 258.713 80.4676 262.208 80.4676Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.208 80.4675V97.646",
    stroke: "white",
    strokeOpacity: 0.08,
    strokeWidth: 2.71244,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.209 86.7964L253.167 94.0294",
    stroke: "white",
    strokeOpacity: 0.08,
    strokeWidth: 2.71244,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.208 86.7964L269.441 92.2212",
    stroke: "white",
    strokeOpacity: 0.08,
    strokeWidth: 2.71244,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.042 84.9882C890.025 84.9882 900.55 70.4157 900.55 52.4395C900.55 34.4634 890.025 19.8909 877.042 19.8909C864.058 19.8909 853.533 34.4634 853.533 52.4395C853.533 70.4157 864.058 84.9882 877.042 84.9882Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.754 81.3716H874.329V101.262H879.754V81.3716Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.5 84.9882C1209.48 84.9882 1222.43 67.1773 1222.43 45.2065C1222.43 23.2357 1209.48 5.4248 1193.5 5.4248C1177.52 5.4248 1164.57 23.2357 1164.57 45.2065C1164.57 67.1773 1177.52 84.9882 1193.5 84.9882Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.12 81.3716H1190.79V103.071H1197.12V81.3716Z",
    fill: "white",
    fillOpacity: 0.06
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1302,
    height: 126.578,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterillustration);
export default __webpack_public_path__ + "static/media/Footer illustration.a9607cc21d51db3dc9744b081ebc1530.svg";
export { ForwardRef as ReactComponent };